export default {
  // Table columns
  'table.match.matchNo': 'Match No.',
  'table.match.brandName': 'Brand',
  'table.match.storeName': 'Store',
  'table.match.tableNo': 'Table No.',
  'table.match.deviceName': 'Device',
  'table.match.matchType': 'Match Type',
  'table.match.playerCount': 'Players',
  'table.match.status': 'Status',
  'table.match.winnerPlayerName': 'Winner',
  'table.match.startedAt': 'Started At',
  'table.match.finishedAt': 'Finished At',
  'table.match.createdAt': 'Created At',
  'table.match.frameRule': 'Frame Rule',
  'table.match.currentProgress': 'Current Progress',
  'table.match.frameNo': 'Frame',
  'table.match.gameNo': 'Game',
  'table.common.actions': 'Actions',

  // Match types
  'matchType.SNOOKER': 'Snooker',
  'matchType.NINE_BALL': 'Nine Ball',
  'matchType.EIGHT_BALL': 'Eight Ball',

  // Match status
  'matchStatus.WAITING': 'Waiting',
  'matchStatus.PLAYING': 'Playing',
  'matchStatus.FINISHED': 'Finished',
  'matchStatus.CANCELLED': 'Cancelled',

  // Win methods
  'winMethod.NORMAL': 'Normal Win',
  'winMethod.NINE_BALL': 'Pocketed 9-Ball',
  'winMethod.EIGHT_BALL': 'Pocketed 8-Ball',
  'winMethod.FOUL': 'Win by Foul',
  'winMethod.FORFEIT': 'Win by Forfeit',
  'winMethod.TIMEOUT': 'Win by Timeout',
  'winMethod.SURRENDER': 'Win by Surrender',

  // Form
  'form.match.brandPlaceholder': 'Select Brand',
  'form.match.storePlaceholder': 'Select Store',

  // Errors
  'error.match.loadListFailed': 'Error loading match list',
  'error.match.loadDetailFailed': 'Failed to load match detail',
  'error.match.notFound': 'Match not found or has been deleted',

  // Detail page - Page titles
  'pages.match.detail.title': 'Match Detail',
  'pages.match.detail.basicInfo': 'Basic Information',
  'pages.match.detail.playerStats': 'Player Statistics',
  'pages.match.detail.frameData': 'Frame & Game Data',
  'pages.match.detail.playerNo': 'No.',
  'pages.match.detail.wonFrames': 'Won Frames',
  'pages.match.detail.wonGames': 'Won Games',
  'pages.match.detail.totalScore': 'Total Score',
  'pages.match.detail.highestScore': 'Highest Score',
  'pages.match.detail.frameNo': 'Frame {0}',
  'pages.match.detail.currentGameNo': 'Game {0}',
  'pages.match.detail.winner': 'Winner',
  'pages.match.detail.noData': 'No data available',
  'pages.match.detail.duration': 'Duration',
  'pages.match.detail.startedAt': 'Started At',
  'pages.match.detail.finishedAt': 'Finished At',
  'pages.match.detail.joinMethod.SCAN': 'Scan to Join',
  'pages.match.detail.joinMethod.ANONYMOUS': 'Anonymous',

  // Detail page - Technical Statistics
  'pages.match.detail.technicalStats': 'Technical Statistics',
  'pages.match.detail.basicStats': 'Basic Statistics',
  'pages.match.detail.successRateStats': 'Success Rate Statistics',
  'pages.match.detail.snookerStats': 'Snooker Statistics',

  // Technical Statistics Fields
  'pages.match.detail.stats.totalPoints': 'Total Points',
  'pages.match.detail.stats.cueHighScore': 'Highest Break',
  'pages.match.detail.stats.raceScore': 'Frames Won',
  'pages.match.detail.stats.ballCount': 'Balls Potted',
  'pages.match.detail.stats.cueCount': 'Total Shots',
  'pages.match.detail.stats.foulCount': 'Fouls',
  'pages.match.detail.stats.errorCount': 'Errors',
  'pages.match.detail.stats.avgShotTime': 'Avg Shot Time',
  'pages.match.detail.stats.avgMistakesPerFrame': 'Avg Mistakes Per Frame',
  'pages.match.detail.stats.tableTopHour': 'Time at Table',
  'pages.match.detail.stats.seconds': 's',
  'pages.match.detail.stats.scoringShots': 'Scoring Shots',
  'pages.match.detail.stats.attemptsShots': 'Attempts',
  'pages.match.detail.stats.potSuccess': 'Pot Success Rate',
  'pages.match.detail.stats.longPotScoringShots': 'Long Pots',
  'pages.match.detail.stats.longPotAttemptsShots': 'Long Pot Attempts',
  'pages.match.detail.stats.longPotSuccess': 'Long Pot Success',
  'pages.match.detail.stats.restPots': 'Rest Pots',
  'pages.match.detail.stats.restAttempts': 'Rest Attempts',
  'pages.match.detail.stats.restPotSuccess': 'Rest Pot Success',
  'pages.match.detail.stats.penaltyPoints': 'Penalty Points',
  'pages.match.detail.stats.breakSequence': 'Century Breaks',
  'pages.match.detail.stats.break50Plus': '50+ Breaks',
  'pages.match.detail.stats.break30Plus': '30+ Breaks',
  'pages.match.detail.stats.redPots': 'Reds Potted',
  'pages.match.detail.stats.redAttempts': 'Red Attempts',
  'pages.match.detail.stats.redPotSuccess': 'Red Pot Success',
  'pages.match.detail.stats.colorPots': 'Colors Potted',
  'pages.match.detail.stats.colorAttempts': 'Color Attempts',
  'pages.match.detail.stats.colorPotSuccess': 'Color Pot Success',
  'pages.match.detail.stats.makeSnookerCount': 'Snookers Laid',
  'pages.match.detail.stats.resolveFailCount': 'Failed Escapes',
  'pages.match.detail.stats.safetySuccess': 'Safety Success',

  // Detail page - Table columns
  'table.matchDetail.gameNo': 'Game No.',
  'table.matchDetail.score': 'Score',
  'table.matchDetail.winner': 'Winner',
  'table.matchDetail.winMethod': 'Win Method',
  'table.matchDetail.duration': 'Duration',
  'table.matchDetail.startedAt': 'Started At',
  'table.matchDetail.finishedAt': 'Finished At',

  // Common
  'common.back': 'Back',
  'common.viewDetail': 'View Detail',
  'table.common.action': 'Action',
};
